import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';

import './App.css';
import Menu          from './components/Layout/Menu';
import Header        from './components/Layout/Header';
import Blog          from './components/Blog/Blog';
import ErrorNotFound from './components/ErrorNotFound/ErrorNotFound';
import Wishlist      from './components/Wishlist/Wishlist';
import Post          from './components/Blog/Post';
import Photos        from './components/Photos/Photos';
import Album         from './components/Photos/Album';
import Login         from './components/Auth/Login';
import Logout        from './components/Auth/Logout';
import Who           from './components/Who/Who';
import FooterCredits from './components/Footer/FooterCredits';
import FooterQuotes  from './components/Footer/FooterQuote';
import Quotes        from './components/Quotes/Quotes';


function App() {
    return (
        <div className="App">
                <Router>
                    <Switch>
                        <Route exact path='/'>
                            <Menu />
                            <Header />
                            <FooterQuotes />
                        </Route>
                        <Route exact path='/blog'>
                            <Menu />
                            <Blog />
                            <FooterQuotes />
                        </Route>
                        <Route path="/wishlist">
                            <Menu />
                            <Wishlist />
                            <FooterQuotes />                           
                        </Route>
                        <Route exac path="/blog/post/:id">
                            <Menu />
                            <Post />
                            <FooterQuotes />
                        </Route>
                        <Route exac path="/photos">
                            <Menu />
                            <Photos />
                            <FooterQuotes />
                        </Route>
                        <Route exac path="/album/:id">
                            <Menu />
                            <Album />
                            <FooterQuotes />
                        </Route>
                        <Route exac path="/login">
                            <Menu />
                            <Login />
                            <FooterQuotes />
                        </Route>
                        <Route exac path="/logout">
                            <Logout />
                        </Route>
                        <Route exact path='/quotes'>
                            <Menu />
                            <Quotes />
                        </Route>
                        <Route exact path='/whoami'>
                            <Menu />
                            <Who />
                            <FooterQuotes />
                        </Route>
                        <Route path="*">
                            <Menu />
                            <ErrorNotFound />
                            <FooterQuotes />
                        </Route>
                    </Switch>
                </Router>
                <FooterCredits />
        </div>
  );
}

export default App;
